import { Injectable } from '@angular/core';
import { AppIcons, IIcons } from '@datachain/ui-sdk/components';

export enum ComponentIcons {
	Help = 'adbComponent:help',
}

@Injectable()
export class AppUiComponentIcons extends AppIcons {
	private readonly path = './assets/img';
	protected override namespace = 'adbComponent';
	protected icons: IIcons = {
		[ComponentIcons.Help]: `${this.path}/live_help_48dp_5F6368_FILL1_wght400_GRAD0_opsz48.svg`,
	};
}
